import { formatCents } from './format';

/** Gemeinsame Formatierung der Seiten EÜR (D-23) und KSt-Erklärung (D-25). */
export const euro = (cents: number) => formatCents(cents);
export const germanDate = (iso: string) => iso.split('-').reverse().join('.');
export const num = { align: 'right' as const, sx: { whiteSpace: 'nowrap' as const } };
/** CSS-Klasse für Einzelheiten, die der Druck "nur Summen" weglässt */
export const DETAIL = 'euer-detail';
